import { defineStore } from "pinia";
export const routeParamsStore = defineStore("routeParams", {
  state: () => ({
    //order params
    orderParams: {},
    //contract params
    contractParams: {},
    //菜单编号
    FunctionCode: "",
    PageParam: {},
    demoParam: {},
    home:'',//跳转主页

  }),
  actions: {
    UpdatePageParam (value) {
      if (value.key !== this.PageParam.key && (value.key || "") !== "") {
        this.PageParam = value;
        this.PageParam.mode = "view"
      }
    },
    setPageParam (value) {

      this.PageParam = value;
      this.demoParam = value;

    },
    getPageParam () {
      return this.PageParam
    },
    setPageMode (value) {
      this.PageParam.mode = value;
    },
    getPageMode () {
      return this.PageParam.mode
    }
  },
  // 所有数据持久化
  persist: true,
  // 持久化存储插件其他配置
  // persist: {
  //     // 修改存储中使用的键名称，默认为当前 Store的 id
  //     key: 'authority',
  //     // 修改为 sessionStorage，默认为 localStorage
  //     storage: localStorage,
  //     // 部分持久化状态的点符号路径数组，[]意味着没有状态被持久化(默认为undefined，持久化整个状态)
  //     paths: ["UserInfo", "RolesFunctionList"],
  // },
})
